<template>
  <component
    :is="highlight"
    :language="content.language"
    :code="content.code"
  />
</template>

<script setup lang="ts">
import hljsVuePlugin from '@highlightjs/vue-plugin'

defineProps({
  content: {
    type: Object,
    required: true,
  },
})

const highlight = hljsVuePlugin.component
</script>

<style lang="scss" scoped>
:deep(.hljs) {
  border-radius: 10px;
  margin: auto;
  background-color: var(--c-foreground);
  border: 1px solid var(--c-background);
  color: var(--c-background);
  width: 100%;

  @include mq(l) {
    width: col(8);
  }
}
</style>
